import React, { CSSProperties, HTMLAttributes } from 'react';

interface BoxProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style'> {
    row?: boolean;
    center?: boolean;
    className?: string;
    styles?: CSSProperties;
    children?: React.ReactNode;
}

const Box = ({ row, center, className = '', styles, children, ...props }: BoxProps) => {
    const classes: string[] = [];
    if (row) classes.push('row');
    if (center) classes.push('center');
    if (className) classes.push(className);

    return (
        <div
            {...props}
            className={`sm-box ${classes.join(' ')}`}
            style={styles}
        >
            {children}
        </div>
    );
};

export default Box;
